export enum ButtonTypesEnum {
  Basic,
  Raised,
  Stroked,
  Flat,
  Icon,
}
